import angular from 'angular';
import DetailedPaymentComponent from './detailed-payment.component';
import DetailedPaymentService from './detailed-payment.service';
import DetailedPaymentConfig from './detailed-payment.config';
import CommentPaymentModalController from "../modal-comment-payment/modal-comment-payment.controller";

let DetailedPaymentModule = angular.module('app.payZone.detailedPayment',[])
  .component('detailedPayment', DetailedPaymentComponent)
  .service('DetailedPaymentService', DetailedPaymentService)
  .config(DetailedPaymentConfig)
  .controller('CommentPaymentModalController', CommentPaymentModalController);


export default DetailedPaymentModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/detailed-payment/detailed-payment.js
 **/